import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import Backend from 'i18next-xhr-backend';

i18n
    .use(Backend)
    .use(initReactI18next)
    .init({
        debug: false,
        lng: 'en',
        fallbackLng: 'en',
        whitelist: [
            'en', 'da-DK', 'fr-BE', 'de-DE', 'it-CH',
            'nl-BE', 'pl-PL', 'sk-SK', 'sv-SE',
            'at-DE', 'be-FR', 'be-NL', 'sz-FR',
            'sz-DE', 'nb-NO', 'sz-IT'
        ],
        backend: {
            // 👇 Loads from wwwroot/locales/{lang}/translation.json + cache buster
            loadPath: '/locales/{{lng}}/translation.json?v=' + new Date().getTime()
        },
        interpolation: {
            escapeValue: false,
        },
        returnEmptyString: false,
        returnNull: false
    });

export default i18n;
